// import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const PREFIX = '_subSection';

const classes = {
  content: `${PREFIX}-content`,
  iconTitle: `${PREFIX}-iconTitle`,
};

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  marginBottom: theme.spacing(4),
  width: '100%',
  [`& .${classes.iconTitle}`]: {
    position: 'relative',
    height: 70,
    '& > div > img': {
      position: 'absolute',
      width: 70,
    },
    '& > .title': {
      marginLeft: 90,
      lineHeight: '70px',
    },
  },
  [`& .${classes.content}`]: {},
}));

interface IProps {
  id?: string;
  title?: string;
  icon?: JSX.Element;
  isBold?: boolean;
  children: JSX.Element;
}

export default function SubSection(props: IProps): JSX.Element {
  const { id, title, children, icon, isBold } = props;

  const renderTitle = () => {
    if (icon) {
      return (
        <div className={classes.iconTitle}>
          <div>{icon}</div>
          <Typography
            className="title"
            variant="h6"
            gutterBottom
            sx={{ fontWeight: isBold ? 'bold' : 'regular' }}
          >
            {title}
          </Typography>
        </div>
      );
    } else if (title) {
      return (
        <Typography variant="h6" gutterBottom sx={{ fontWeight: isBold ? 'bold' : 'regular' }}>
          {title}
        </Typography>
      );
    } else {
      return null;
    }
  };

  return (
    <Root id={id}>
      {renderTitle()}
      <div className={classes.content}>{children}</div>
    </Root>
  );
}
